import React, { useState, useEffect, useContext,useCallback } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import CarnivalForm from './createDuplicateCarnivalForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import 'react-toastify/dist/ReactToastify.css';

const AddDuplicateCarnival = ({
  match,
  history,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  createDuplicateCarnival,
  getCarnivalDataForUpdation,
  carnivalData,
}) => {
  const { id } = useParams();
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const [siteId, setSiteId] = useState(null);

  //For Getting Carnival Data
  const getCarnivalData = useCallback(async () => {
    if (match?.params?.id) {
      setIsLoading(true);
      await getCarnivalDataForUpdation(match?.params?.id);
      setIsLoading(false);
    }
  }, [getCarnivalDataForUpdation, match?.params?.id]);

  useEffect(() => {
    getCarnivalData();
  }, [getCarnivalData]);


  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    setSiteId(meetingDetails.site_id);
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      toast.error('Please fill Start & End Date & time.');
      return false;
    } else {
      // let isNotEmpty = true;
      // isNotEmpty = meetingDetails.services.map((x,i) => {
      //       if (x.id == 1 || x.id == 2) {
      //         return (!!(x?.price)) ? (
      //             true
      //         ) : false
      //       } else {
      //         return true;
      //       }
      //     }
      // );
      // if (isNotEmpty.includes(false)) {
      //   toast.error('Please fill all services details!');
      //   return;
      // }

      if (
        Array.isArray(meetingDetails.partners) &&
        meetingDetails.partners.length > 0 &&
        meetingDetails.partners.some(
          (partner) =>
            (partner.companyName?.trim() && !partner.cost?.trim()) ||
            (!partner.companyName?.trim() && partner.cost?.trim())
        )
      ) {
        toast.error(`Please fill both Company Name and Cost for all partners`);
        return;
      }

      setIsFiled(false);
      (async () => {
        const res = await createDuplicateCarnival(meetingDetails);
        if (res?.data.saved == 1) {
          setIsModal(true);
        } else {
            toast.error('Carnival already exists within given dates!');
        }
      })();
    }
  };

  const handleModalHide2 = () => {
    // setIsInfraIdMissingModal(false);
    history.push(`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${siteId}`);
    // history.push(`${baseUrl}/brand-activation/conduct-carnival/carnival`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.scheduleCarnival}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={localization.scheduleCarnival}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp`}
    >
      <CarnivalForm
        handleValue={handleForm}
        documentUploadUrl={documentUploadUrlPublic}
        documentUrlData={documentUrlDataPublic}
        prefilledData={carnivalData}
        isUpdate
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.carnivalSuccess}</h5>
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToCarnivalListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      
    </Layout>
  );
};

AddDuplicateCarnival.propTypes = {};

export default AddDuplicateCarnival;
